import { createAsyncThunk, EntityId } from '@reduxjs/toolkit';

export const deleteOneserveurType = createAsyncThunk(
    '[serveur-TYPE] deleteOneserveurType',
    async (id: EntityId, thunk: any) => {
        try {
            return thunk.extra.serveurTypeQuery._delete(id);
        } catch (error: any) {
            return thunk.rejectWithValue({ message: error.message ?? null });
        }
    }
);
